var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 10.44H7.35C3.25 10.44 2 11.69 2 15.79V17.65C2 21.75 3.25 23 7.35 23H16.65C20.75 23 22 21.75 22 17.65V15.79C22 11.69 20.75 10.44 16.65 10.44ZM12 19.74C10.33 19.74 8.98 18.38 8.98 16.72C8.98 15.06 10.33 13.7 12 13.7C13.67 13.7 15.02 15.06 15.02 16.72C15.02 18.38 13.67 19.74 12 19.74Z",
    fill: "#D6EDFF",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.11997 10.42V6.75006C7.11997 3.82006 7.94997 1.87006 12 1.87006C16.33 1.87006 16.88 3.98006 16.88 5.82006C16.88 6.21006 17.19 6.52006 17.58 6.52006C17.97 6.52006 18.28 6.21006 18.28 5.82006C18.28 2.27006 16.17 0.470062 12 0.470062C6.36997 0.470062 5.71997 4.05006 5.71997 6.75006V10.5C6.13997 10.45 6.60997 10.42 7.11997 10.42Z",
    fill: "#D6EDFF",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.ac0f1006937b867b2b84db3742e0ade2.svg";
export { ForwardRef as ReactComponent };